import React from 'react';
import { motion } from 'framer-motion';
import { BrainCircuit } from 'lucide-react';
import { ConsultationForm } from '../components/ConsultationForm';

const springConfig = {
  type: "spring",
  stiffness: 50,
  damping: 20,
  mass: 1
};

export const Consultation = () => {
  return (
    <div className="pt-24 px-4 min-h-screen">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ...springConfig }}
          className="text-center mb-12"
        >
          <div className="flex justify-center mb-6">
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={springConfig}
              className="relative"
            >
              <BrainCircuit className="w-16 h-16 text-amber-400" />
              <motion.div
                animate={{
                  scale: [1, 1.1, 1],
                  opacity: [0.5, 0.8, 0.5],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute inset-0 bg-amber-400/10 rounded-full filter blur-2xl"
              />
            </motion.div>
          </div>
          <h1 className="text-4xl font-bold mb-4">
            <span className="bg-gradient-to-r from-amber-200 to-amber-400 text-transparent bg-clip-text">
              Schedule Your Free Consultation
            </span>
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Take the first step towards optimizing your business with AI-powered insights
          </p>
        </motion.div>

        <ConsultationForm />

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 1 }}
          className="mt-8 text-center text-gray-400 text-sm"
        >
          By submitting this form, you agree to be contacted about ProfitIQ.AI's services.
          We respect your privacy and will never share your information.
        </motion.div>
      </div>
    </div>
  );
};